import React, { useEffect, useReducer, useMemo } from 'react'
import { Box,IconButton } from '@mui/material'
import Table2,{TableHook} from '../../../Table/indexSec';
import { lockedReducer } from '../../../Utils/reducers';
import EditIcon from '@mui/icons-material/Edit';
import EditGrupoFilial from './edit';
import clsx from 'clsx';

const url = 'grupo_filial'

const columns = (setState) => {
    const columns = []
    columns.push({field: 'nome', headerName: 'Nome', flex:0.2, cellClassName: () => {return clsx('center',{selected:true,});}})
    columns.push({field: 'filiais', headerName: 'Filiais', flex:0.9, cellClassName: () => {return clsx('center',{selected:true,});}})
    columns.push({field: 'default_name', headerName: 'Nome default', flex:0.7, cellClassName: () => {return clsx('center',{selected:true,});}})
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        flex: 0.4,
        renderCell: (props) => {
            return(
                <Box>
                    <IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton>
                </Box>
            )
        },
        cellClassName: () => {return clsx('center',{selected:true,});}
      })
      
    return columns
}

const GrupoFilial = () => {

        const [state, setState] = useReducer(lockedReducer, {
            rows: [],
            editRow: null
        })
        
        const [table, reloadTable] = TableHook()

        const reloadData = () => {
            reloadTable()
        }


        useEffect(() => {
        }, [])
        

    return(
        <>

        {
            state.editRow &&

            <EditGrupoFilial
                data={state.editRow}
                handleClose={() => setState({ editRow: null })}
                reloadData={reloadData}
            />
           
        }

        <Box sx={{height:'100%'}}>
           
                <Table2
                    paginationMode='client'
                    className='contabil-grid'
                    rows={state.rows}
                    columns={useMemo(()=> columns(setState), [state.rows, state.edit])}
                    pagination={false}
                    toolbar
                    slots={{
                        addComponent: () => setState({ editRow: {} })
                    }}
                    getURL={url}
                    updateRows={(rows) => setState({'rows': rows})}
                    density='compact'
                    rowHeight={30}
                    innerRef={table}
                    sx={{height:'100%'}}
                />
           
        </Box>
        
        </>
    )
}

export default GrupoFilial;